const COLOR_PAIRS: [string, string][] = [
  ["bg-blue-100", "text-blue-700"],
  ["bg-green-100", "text-green-700"],
  ["bg-purple-100", "text-purple-700"],
  ["bg-orange-100", "text-orange-700"],
  ["bg-pink-100", "text-pink-700"],
  ["bg-teal-100", "text-teal-700"],
  ["bg-indigo-100", "text-indigo-700"],
  ["bg-yellow-100", "text-yellow-800"],
];

const HEX_COLORS: string[] = [
  "#3b82f6", // blue-500
  "#22c55e", // green-500
  "#a855f7", // purple-500
  "#f97316", // orange-500
  "#ec4899", // pink-500
  "#14b8a6", // teal-500
  "#6366f1", // indigo-500
  "#ca8a04", // yellow-600
];

function hashId(id: string): number {
  let h = 0;
  for (let i = 0; i < id.length; i++) {
    h = (Math.imul(31, h) + id.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

export function getAvatarColor(userId: string): { bg: string; text: string } {
  const [bg, text] = COLOR_PAIRS[hashId(userId) % COLOR_PAIRS.length];
  return { bg, text };
}

export function getAvatarHexColor(userId: string): string {
  return HEX_COLORS[hashId(userId) % HEX_COLORS.length];
}
